// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__VE91D","default":"Tag_default__Vd_zM","primary":"Tag_primary__htqqW","small":"Tag_small__xd8xF"};